(() => {
  let delay;
  let timeout;
  let visual;
  let status;
  function clear() {
    clearTimeout(delay);
    clearTimeout(timeout);
    visual?.remove();
    status?.remove();
    visual = status = null;
  }
  function start() {
    clear();
    delay = setTimeout(() => {
      visual = document.createElement('span');
      visual.className = 'drp-loading-visual drp-loading-visual--navigation';
      visual.setAttribute('aria-hidden', 'true');
      for (let i = 0; i < 3; i++) visual.append(document.createElement('span'));
      document.body.append(visual);
      status = document.createElement('span');
      status.className = 'drp-loading-status';
      status.setAttribute('role', 'status');
      document.body.append(status);
      status.textContent = window.DrapeurLoadingLabel || '';
    }, 250);
    timeout = setTimeout(clear, 10000);
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey
      || link.hasAttribute('download') || (link.target && link.target !== '_self')
      || link.matches('[data-load-more-next], [role="button"]')) return;
    const url = new URL(link.href, location.href);
    const current = new URL(location.href);
    // Same-page filters, pagination, anchors and AJAX controls are not page navigation.
    if (url.origin !== current.origin || !/^https?:$/.test(url.protocol)
      || url.pathname === current.pathname
      || /\/(cart|checkout|account)(\/|$)/.test(url.pathname)
      || /\.[a-z0-9]{2,5}$/i.test(url.pathname)) return;
    queueMicrotask(() => { if (!event.defaultPrevented) start(); });
  });
  // A continued gesture means the visitor is still using the current page.
  for (const name of ['scroll', 'touchmove', 'wheel', 'pointerdown', 'keydown']) {
    window.addEventListener(name, clear, { passive: true });
  }
  window.addEventListener('pagehide', clear);
  window.addEventListener('pageshow', clear);
  document.addEventListener('collection:before-render', clear);
  document.addEventListener('collection:reloaded', clear);
})();
